import React from 'react';
import { isIOS } from 'react-device-detect';
import { Grid, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import { LargePageLineText } from '../@common/PageLineText';
import BaseInput from '../@common/BaseInput';
import { WorksheetBaseProps } from '../@types';
import NameAndDateLines from '../@common/NameAndDateLines';
import GroupedPageLines from '../@common/GroupedPageLines';
import { translate } from '../../translations/translator';

const t = key => translate('worksheet', key);

type WordsAndSpellingProps = WorksheetBaseProps & {
  value: string;
  rows: number;
  cols: number;
  isSpelling: boolean;
  valueMap: any;
  printRef?: React.RefObject<HTMLDivElement>;
};

const WordsAndSpellingPrekTo1 = ({
  onChange,
  rows,
  cols,
  isSpelling,
  valueMap,
  printRef
}: WordsAndSpellingProps) => {
  const bookFont = 'Print-Wide-Book';
  const fontSize = 60;

  const numOfRowsArray = [...Array(rows).keys()];
  const numOfColsArray = [...Array(cols).keys()];

  const classes = useStyles();
  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  const baseInputStyles: any = {
    fontFamily: bookFont,
    color: '#000',
    style: {
      fontSize: fontSize,
      width: isSpelling ? 450 : 275,
      marginLeft: '40px',
      marginTop: isIOS ? '-34.5px' : '-35px',
      color: '#000',
      position: 'relative !important',
      maxWidth: 900
    }
  };

  let itemNum = 0;

  const renderWordsOrSpelling = (value, num) => {
    if (isSpelling) {
      return (
        <>
          <Grid item xs={6}>
            <Paper className={classes.paperSpelling}>
              <LargePageLineText>
                <div className={classes.pageNumber}>{itemNum}.</div>
                <BaseInput
                  onChange={({ target }) => {
                    handleChange(num, target.value);
                  }}
                  showBackground={true}
                  {...baseInputStyles}
                  placeholder={t('word')}
                  aria-label={`${t('word')} ${itemNum}`}
                  fontSize={66}
                  value={value}
                />
              </LargePageLineText>
              <GroupedPageLines width={450} isWide paddingTop={30} />
            </Paper>
          </Grid>
          <Grid item xs={6}>
            <Paper className={classes.paperSpelling}>
              <GroupedPageLines width={450} isWide paddingTop={30} />
            </Paper>
          </Grid>
        </>
      );
    }
    return (
      <Grid item xs={4} component={'li'}>
        <Paper className={classes.paper}>
          <LargePageLineText>
            <div className={classes.pageNumber}>{itemNum}.</div>
            <BaseInput
              onChange={({ target }) => handleChange(num, target.value)}
              showBackground={true}
              {...baseInputStyles}
              placeholder={t('word')}
              aria-label={`${t('word')} ${itemNum}`}
              fontSize={66}
              value={value}
            />
          </LargePageLineText>
          <GroupedPageLines width={275} isWide paddingTop={30} />
          <GroupedPageLines width={275} top={55} isWide paddingTop={30} />
        </Paper>
      </Grid>
    );
  };

  return (
    <LandscapePaperLayout isWide printRef={printRef}>
      <NameAndDateLines fontFamily={bookFont} isWide width={1000} top={-25} />
      <div
        className={classes.root}
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          top: 162,
          margin: '0px 0 30px',
          padding: '50px 20px 20px 20px',
          fontSize: fontSize
        }}
      >
        <Grid container spacing={1} component={'ul'}>
          <ul
            style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%' }}
            aria-label={t(isSpelling ? 'wordsList' : 'spellingList')}
          >
            {numOfRowsArray.map(row => (
              <Grid container item spacing={3} component={'li'}>
                {numOfColsArray.map(col => {
                  itemNum++;
                  return renderWordsOrSpelling(valueMap[itemNum], itemNum);
                })}
              </Grid>
            ))}
          </ul>
        </Grid>
      </div>
    </LandscapePaperLayout>
  );
};

export default WordsAndSpellingPrekTo1;
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginTop: '-10px !important'
  },
  paper: {
    margin: '65px 0px',
    textAlign: 'center',
    border: 'none',
    boxShadow: 'none'
  },
  paperSpelling: {
    margin: '25px 0px',
    textAlign: 'center',
    border: 'none',
    boxShadow: 'none'
  },
  pageNumber: {
    marginRight: 10
  }
}));
